/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, Output,
} from '@angular/core';

let nextId = 0;

// A type-to-filter select for the Projects filter row, in place of a native select.
// Typing narrows the options here, not on the page. Clearing the control emits null.
@Component({
  selector: 'ut-filter-select',
  templateUrl: './filter-select.component.html',
  styleUrls: ['./filter-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FilterSelectComponent {
  @Input() label = '';
  @Input() options: string[] = [];
  @Input() value: string | null = null;
  @Input() placeholder = '';

  @Output() valueChange = new EventEmitter<string | null>();

  readonly labelId = `ut-filter-select-label-${nextId++}`;
  query = '';

  get shownOptions(): string[] {
    const query = this.query.toLowerCase();
    return (this.options || []).filter((option) => String(option).toLowerCase().includes(query));
  }

  onSelect(value: string | null): void {
    // The typed text stays in the hidden search box after a pick. Drop it, so the next open lists every option.
    this.query = '';
    this.valueChange.emit(value || null);
  }
}
